module.exports = __webpack_public_path__ + "img/columns-gap.8cd15838.svg";